import React from 'react';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import Bugsnag from '@bugsnag/js';
import config from './config';
import pkg from '../package.json';

let ErrorBoundary = 'div';

if (config.bugsnagKey && process.browser) {
  Bugsnag.start({
    apiKey: config.bugsnagApiKey,
    plugins: [new BugsnagPluginReact()],
    appVersion: pkg.version,
    metadata: {
      reseller: {
        id: config.reseller,
        name: config.companyName
      }
    }
  });

  ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
}

export const bugsnagClient = Bugsnag; // fallback
export default ErrorBoundary;
